import React, { useState } from "react";
import {
  Dialog, DialogActions, DialogContent, DialogContentText, Box
} from '@mui/material';
import sendRequest from '../utils/sendRequest'
import GavelIcon from '@mui/icons-material/Gavel';
import { MenuButtonIcon, SubmitButton, CancelButton, DangerButton } from "../styled/CustomButtons";
import { ButtonSpinnerWhite } from "../styled/CustomSpinners";
import { CustomDialogTitle } from "../styled/DialogTitles";

export default function ApprovePoDialog({ po_doc_id, poName, addSnackbar, fetchPoDetails=null, fetchPos=null, isIcon=false }) {
  const [open, setOpen] = useState(false);
  const [loadingApproval, setLoadingApproval] = useState(false);
  const [loadingDenial, setLoadingDenial] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    if (!loadingApproval && !loadingDenial) {
      setOpen(false);
    }
  };

  const approvePo = async (po_doc_id) => {
    handleClose();
    setLoadingApproval(true);
    try {
      let response = await sendRequest(`purchase-orders/approve?po_doc_id=${po_doc_id}`);
      addSnackbar(response.message);
      isIcon ? fetchPos() : fetchPoDetails();
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      setLoadingApproval(false);
    }
  }

  const denyPo = async () => {
    setLoadingDenial(true);
    try {
      let response = await sendRequest(`purchase-orders/deny_approval?po_doc_id=${po_doc_id}`);
      addSnackbar(response.message);
      handleClose();
      isIcon ? fetchPos() : fetchPoDetails();
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      setLoadingDenial(false);
    }
  }

  return (
    <Box>
      <MenuButtonIcon
        isIcon={isIcon}
        title={"Approve/Deny"}
        text={"Approve/Deny Purchase"}
        icon={GavelIcon}
        onClick={handleOpen}
      >{loadingApproval && (<ButtonSpinnerWhite />)}</MenuButtonIcon>
      <Dialog
        open={open}
        onClose={handleClose}
        disableEscapeKeyDown={loadingApproval || loadingDenial}
      >
        <CustomDialogTitle
          header={"Approve/Deny PO for Purchase"}
          poName={poName}
        />
        <DialogContent>
          <DialogContentText>
            Are all products and prices approved for purchase?
          </DialogContentText>
        </DialogContent>
          <DialogActions
            sx={{ display: 'flex', justifyContent: 'space-between', px: 3, pb: 2 }}
          >
            <CancelButton
              onClick={handleClose}
              disabled={loadingApproval || loadingDenial}
            >
              Cancel
            </CancelButton>

            <Box sx={{ display: 'flex', gap: 2 }}>
              <DangerButton
                showSpinner={loadingDenial}
                text={"Deny"}
                onClick={() => denyPo(po_doc_id)}
                disabled={loadingApproval || loadingDenial} 
              />
              <SubmitButton
                showSpinner={false}
                text={"Approve"}
                onClick={() => approvePo(po_doc_id)}
                disabled={loadingApproval || loadingDenial}
              />
            </Box>
          </DialogActions>
      </Dialog>
    </Box>
  )
}